// pl_pms_guests.ts
// Tłumaczenia dla PMS.Guests.tsx

export const plPmsGuests = {

  title: "Goście",
  addGuest: "Dodaj gościa",
  adding: "Dodawanie gościa...",
  backToGuests: "Powrót do listy gości",

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    name: "Imię i nazwisko",
    email: "E-mail",
    phone: "Telefon",
    country: "Kraj",
    address: "Adres",
    arrivalTime: "Godzina przyjazdu",
    arrival: "Przyjazd",
    departure: "Wyjazd",
    adultsChildren: "Dorośli / Dzieci",
    balanceDue: "Kwota do zapłaty",
    billingCompany: "Dane firmy do faktury",
    activeFolio: "Aktywna karta pobytowa",
    actions: "Akcje",
  },

  // ── Walidacja ─────────────────────────────────────────────────────────────
  validation: {
    arrivalDeparture: "Pobyt musi obejmować co najmniej jedną noc.",
  },

} as const;

export default plPmsGuests;